var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('NewsPanel',[_c('span',{attrs:{"slot":"title"},slot:"title"},[_vm._v("所有訊息")])])],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }